export enum SupplierIdentificationTypeEnum {
    nif = "nif",
}

export class SupplierIdentificationType {
    constructor(
        public readonly id: SupplierIdentificationTypeEnum,
        public readonly label: string,
    ) {}
}
